import React from 'react';
import { Bell, Sun, Moon, Search, LogOut } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { useAdminAuth } from "../../context/Adminauthcontext";
import './TopBar.css';

export default function TopBar({ title, subtitle }) {
  const { theme, toggleTheme }  = useTheme();
  const { admin, logout }       = useAdminAuth();

  const initials = admin?.name?.split(' ').map(n => n[0]).join('').slice(0,2) || 'AD';
  const greeting = () => {
    const h = new Date().getHours();
    if (h < 12) return 'Good morning';
    if (h < 17) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <header className="topbar">
      <div className="topbar__left">
        <h2 className="topbar__title">{title}</h2>
        {subtitle && <p className="topbar__subtitle">{subtitle || `${greeting()}, ${admin?.name?.split(' ')[0]}`}</p>}
      </div>
      <div className="topbar__right">
        <div className="topbar__search">
          <Search size={14} />
          <input className="topbar__search-input" placeholder="Search anything..." />
        </div>
        <button className="topbar__icon-btn" onClick={toggleTheme} aria-label="Toggle theme">
          {theme === 'light' ? <Moon size={17} /> : <Sun size={17} />}
        </button>
        <button className="topbar__icon-btn topbar__notif" aria-label="Notifications">
          <Bell size={17} />
          <span className="topbar__notif-dot" />
        </button>
        {/* Admin avatar */}
        <div className="topbar__user">
          <div className="topbar__user-avatar-wrap">
            <img
              src="/images/admin/admin-avatar.jpg"
              alt={admin?.name || 'Admin'}
              className="topbar__user-avatar-img"
              onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
            />
            <div className="topbar__user-avatar" style={{ display: 'none' }}>{initials}</div>
          </div>
        </div>
        {/* Logout shortcut */}
        <button className="topbar__icon-btn" onClick={logout} title="Sign Out" aria-label="Sign Out">
          <LogOut size={16} />
        </button>
      </div>
    </header>
  );
}